import { useTypeSelector } from '../../../store';
import { selectGetSearchSettingsByIdLoader, selectedSearchSettingsItem } from '../../../selectors/landings';
import { createLoadHoc } from '../../../helpers/hocs/createLoadHoc';
import { FaqSectionContent } from '../../../components/Faq';

const FaqLandingContent = () => {
    const selectedLanding = useTypeSelector(selectedSearchSettingsItem);

    return (
        <FaqSectionContent
            title="FAQ посадочной"
            subtitle={selectedLanding?.string || ''}
            entityId={selectedLanding?.id}
            filterKey="oftenSearchedId"
        />
    );
};

const loader = createLoadHoc({
    selectLoader: selectGetSearchSettingsByIdLoader,
});

const FaqLanding = loader(FaqLandingContent);

export default FaqLanding;
